import styled from 'styled-components/macro';
import Tabs from './components/Tabs';
import Squad from './components/Squad';
import Stats from './components/Stats';

export const PreviousContainer = styled.div`
  position: relative;
  display: grid;
  width: 100%;
  grid-template-columns: ${({ tabletMode }) =>
    tabletMode ? `auto auto 426px` : `35% 30% 35%`};
  grid-template-rows: auto 1fr;
  grid-template-areas: ${({ tabletMode }) =>
    tabletMode
      ? `"header header stats"
    "squad squad stats"`
      : `"local stats away"`};
  flex-grow: 1;
`;

export const ContainerSm = styled.div`
  padding-bottom: 42px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
`;

export const TabsSections = styled(Tabs)`
  position: sticky;
  top: 0;
  grid-area: header;
  z-index: 2;
  border-top: solid 1px ${({ theme }) => theme.gray3};
`;

export const LocalSquad = styled(Squad)`
  grid-area: ${({ tabletMode }) => (tabletMode ? 'squad' : 'local')};
`;

export const MatchStats = styled(Stats)`
  grid-area: stats;
`;

export const AwaySquad = styled(Squad)`
  grid-area: ${({ tabletMode }) => (tabletMode ? 'squad' : 'away')};
`;
